



























import { genVuexComputeds } from '@/main/pages/editFactory';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import { Doklad } from '@/modules/servis/doklad';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { saveButton, deleteButton } from '@/main/utils/tableOperations';

import { Cell, getColumnsRowMapObject } from '@/main/utils/table';
import { apiProvider } from '@/modules/servis/zakazka/api';
import { showAlert } from '@/main/utils/notifications';
import { forceFileDownload, validateFiletype } from '@/main/utils/fileHelper';

import { NAME, FILE_TYPE } from './constants';
import { store } from '../../store/edit';
import { ZAKAZKA_DRUH } from '../../constants';

export default EditStoreMixin.extend({
	name: 'AttachmentFiles',
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			NAME,
			Attachment_Files: Doklad.name,
			fileList: [] as any[],
			fileListNonGenuine: [] as any[],
			saveButton,
			deleteButton,
			enablesubmit: false,
			disableFileUpload: false,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
	mounted() {
		if (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI && !this.VozidloId) {
			this.disableFileUpload = true;
		}
	},
	methods: {
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		handleRemoveNonGenuineFiles(file: File, fileListNonGenuine: []) {
			this.fileListNonGenuine = fileListNonGenuine;
		},
		handleChangeNonGenuineFiles(file: Record<string, any>) {
			this.fileListNonGenuine = [file];
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		async submitAttachmentUpload() {
			const selectedFile = this.fileList[0];
			const validateFile = validateFiletype(selectedFile, 2000000, FILE_TYPE);
			if (validateFile.result) {
				this.enablesubmit = true;
				const Uploadresult = await apiProvider.saveDocument(selectedFile, this.ZakazkaId);
				if (Uploadresult) {
					showAlert({
						message: this.LocalizeChyboveHlasky('FileUploadSuccess'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}
				this.fileList = [];
				await this.refreshTable(NAME);
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
		},
		async submitNonGenuineAttachment() {
			if (this.fileListNonGenuine[0] && validateFiletype(this.fileListNonGenuine[0], 2000000, FILE_TYPE)) {
				await apiProvider.nonGenuineSaveDocument(this.fileListNonGenuine[0], this.VozidloId, this.edit.IsTotalLoss === null ? false : this.edit.IsTotalLoss);
				this.fileListNonGenuine = [];
				this.fetchTableData(['NonGenuineAttachmentFiles']);
			}
		},
		async attachamentFilesDelete(e: Event, cells: Cell[]) {
			const result = await apiProvider.deleteAttachamentDocuments(cells[0]);
			if (result) {
				showAlert({
					message: this.LocalizeChyboveHlasky('FileDeleteSuccess'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'success',
					},
				});
			}

			this.fetchTableData([NAME]);
		},

		async nonGenuineAttachamentFilesDelete(e: Event, cells: Cell[]) {
			const result = await apiProvider.deleteNonGenuineAttachamentDocuments(cells[0]);
			if (result) {
				showAlert({
					message: this.LocalizeChyboveHlasky('FileDeleteSuccess'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'success',
					},
				});
			}
			this.fetchTableData(['NonGenuineAttachmentFiles']);
		},

		async attachmentFilesDownload(e: Event, cells: Cell[]) {
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const MappedRow = getColumnsRowMapObject(this.dependentTables.AttachmentFiles.columns, cells) as any;
			const file = await apiProvider.getDocuments(MappedRow.FILE_ID ? MappedRow.FILE_ID : MappedRow.FileId);
			const url = `data:application/octet-stream;base64,${file.data}`;
			forceFileDownload(url, MappedRow.FILE_NAME ? MappedRow.FILE_NAME : MappedRow.FileName);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},

		async nonGenuineAttachamentFilesDownload(e: Event, cells: Cell[]) {
			const MappedRow = getColumnsRowMapObject(this.dependentTables.NonGenuineAttachmentFiles.columns, cells) as any;
			const file = await apiProvider.getNonGenuineDocuments(MappedRow.FILE_ID ? MappedRow.FILE_ID : MappedRow.FileId);
			const url = `data:application/octet-stream;base64,${file.data}`;
			forceFileDownload(url, MappedRow.FILE_NAME ? MappedRow.FILE_NAME : MappedRow.FileName);
		},
	},
});
